import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'bas-footer-copyright',
	templateUrl: './footer-copyright.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class FooterCopyrightComponent {}
